import React from 'react';
import { useTranslation } from 'react-i18next';
import PartyOutstandingReport from '@/components/finance/report-document/PartyOutstandingReport';

export const SupplierOutstandingPage: React.FC = () => {
  const { t } = useTranslation('finance');
  return (
    <div aria-label={t('supplierOutstanding')}>
      <PartyOutstandingReport party="supplier" />
    </div>
  );
};

export default SupplierOutstandingPage;
